/* esm.sh - debug@4.4.3 */
import "/node/process.mjs";
export * from "/*debug@4.4.3/esnext/debug.mjs";
export { default } from "/*debug@4.4.3/esnext/debug.mjs";
